import {EQCompanyData, initializeCompanyData} from "./EQCompanyData";

export interface EQCompany {
  // 사업체
  //DBField
  uid: number; // 고유값
  guid: string; // GUID
  name: string; // 업체명
  phone: string; // 전화번호
  address: string; // 주소
  companyLogo: string; // 업체 로고
  companyCode: string; // 업체 코드(영문 알파벳만 가능 - 서브도메인에 사용됨)
  creatorUID: number; // 작성자 UID
  modifierUID: number; // 수정자 UID
  isDeleted: boolean; // 삭제 여부

  entryDate: Date | string; // 등록일
  modifyDate: Date | string; // 수정일

  //Non DB
  base64: string;
  archiveSize: number;
  companyData: EQCompanyData;
}

export const initializeCompany = (): EQCompany => {
  return {
    uid: 0, // 고유값
    guid: "00000000-0000-0000-0000-000000000000", // GUID
    name: "", // 업체명
    phone: "", // 전화번호
    address: "", // 주소
    companyLogo: "", // 업체 로고
    companyCode: "", // 업체 코드(영문 알파벳만 가능 - 서브도메인에 사용됨)
    creatorUID: 0, // 작성자 UID
    modifierUID: 0, // 수정자 UID
    isDeleted: false,

    entryDate: new Date(), // 등록일
    modifyDate: new Date(), // 수정일

    //Non DB
    base64: "",
    archiveSize: 0,
    companyData: initializeCompanyData(),
  };
};

export interface CompanyListParams {
  token: string;
  page: number;
  rows?: number;
}
export const initialCompanyListParams = {
  page: 1,
  token: "",
  rows: 20,
};
